const TabScreen = ({ component, ...props }) => {
  if (typeof component === 'function') {
    const Component = component;
    return <Component {...props} />;
  }

  return component;
};

TabScreen.displayName = 'TabScreen';
export default TabScreen;
